import { cn } from "@/lib/utils";
import Image from "next/image";

interface NotificationProps {
  text: string;
  date: string;
  className?: string;
}

export default function Notification({
  text,
  date,
  className,
}: NotificationProps) {
  return (
    <div className="w-full z-10">
      <div
        className={cn(
          "bg-gradient-to-b from-white to-slate-100 border border-slate-200/80 shadow-sm shadow-white inset-shadow-sm inset-shadow-slate-50 rounded-2xl p-4 w-full flex gap-2.5",
          className
        )}
      >
        <div className="bg-white border border-slate-200 h-10 w-10 rounded-xl flex-none p-2.5">
          <Image
            src="/web-app-manifest-192x192.png"
            alt="Logo"
            width={100}
            height={100}
            loading="lazy"
            className="w-full"
          />
        </div>
        <div className="flex gap-2 justify-between w-full">
          <div className="leading-5.5">
            <span className="font-medium">Featcal</span>
            <p className="text-slate-600">{text}</p>
          </div>
          <p className="text-slate-600 text-xs flex justify-end w-[100px]">
            {date}
          </p>
        </div>
      </div>
    </div>
  );
}
